module.exports = __webpack_public_path__ + "static/img/数字影院.6ac3dffb.png";